import React, {RefObject} from "react";
import {css} from "@emotion/react";

import {calculateRemSize as crs} from "@pg-design/helpers-css-strings";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";

interface IProps {
    scrollRefElem: RefObject<HTMLDivElement | null>;
}

export function OfferRankingCreationSteps(props: IProps) {
    const {scrollRefElem} = props;

    return (
        <div css={creationSteps} ref={scrollRefElem}>
            <Text variant="headline_3" as="h2" align="center">
                Zobacz, jak powstał ranking
            </Text>

            <Text variant="body_copy_0" align="center" css={outro}>
                Ranking powstał na podstawie analizy odwiedzin stron inwestycji opublikowanych na {concatWithBrandName("")} w całym <b>2024 roku</b>. W sumie
                wyłoniliśmy <b>10 najpopularniejszych osiedli</b>, które cieszyły się największym zainteresowaniem naszych użytkowników.
                <br />
                Na tej podstawie stworzyliśmy finałowe zestawienie, w którym wskazaliśmy <b>3 laureatów</b> oraz przyznaliśmy <b>2 wyróżnienia</b> dla
                inwestycji w każdym z miast.
            </Text>
        </div>
    );
}

// Styles
const creationSteps = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    justify-content: center;
    align-items: center;
    max-width: 1128px;
`;

const outro = css`
    max-width: 552px;
`;
